import api from './axios';

export const customersApi = {
  getAll: (type?: string) => api.get('/customers', { params: { type } }),
  getById: (id: number) => api.get(`/customers/${id}`),
  getByDocument: (document: string) => api.get(`/customers/document/${document}`),
  create: (data: any) => api.post('/customers', data),
  update: (id: number, data: any) => api.put(`/customers/${id}`, data),
  delete: (id: number) => api.delete(`/customers/${id}`),
};
